import moment from 'moment';

import { PersonCategory, TySelectInvitationOptionData } from './TySelectInvitationTypes';
import { attendanceRateCalculation, getCzechConjugationForShiftNoun } from './TySelectInvitationUtils';
import { ActionIcon, FavouriteIcon, HomeIcon } from '@tymbe/ui-icons';

const TySelectInvitationOption = ({ option }: { option: TySelectInvitationOptionData }) => {
  const { first_name, middle_name, last_name, category, application, personData, id, blocks, activeBan } = option;
  const name = `${first_name} ${middle_name ?? ''} ${last_name}`;
  let additionalTxt = '';

  switch (category) {
    case PersonCategory.Newbie:
      additionalTxt = `Naposled u vás ${moment(application![0]?.shift?.end_time).format('DD.MM.YYYY')}`;
      break;
    case PersonCategory.BestRated:
      additionalTxt = 'Dostal/a pozitivní hodnocení';
      break;
    case PersonCategory.MostAttendancesInMonth:
    case PersonCategory.MostAttendancesInYear: {
      const count = application?.length || 0;
      const suffix = getCzechConjugationForShiftNoun(count);
      // additionalTxt = `V posledním ${category === PersonCategory.MostAttendancesInMonth ? 'měsíci' : 'roce'} ${count} ${suffix}`;
      additionalTxt = `Vysoká docházka za poslední ${category === PersonCategory.MostAttendancesInMonth ? 'měsíc' : 'rok'}`;
      break;
    }
    case PersonCategory.Blocked:
      if (activeBan !== null) {
        additionalTxt = 'Ban';
      } if (blocks.company) {
        additionalTxt = 'Blokace na firmu';
      } if (blocks.branchoffice) {
        additionalTxt = 'Blokace na provozovnu';
      } if (blocks.department) {
        additionalTxt = 'Blokace na oddelení';
      }
      break;
    default:
      break;
  }

  const attendanceRate = attendanceRateCalculation(personData?.attendanceCount, personData?.applicationCount);

  return (
    <div className="@container flex flex-row justify-between items-center cursor-pointer rounded-lg hover:bg-base-back-1 px-3 py-2">
      <div className="flex flex-col">
        <div className="text-sm font-geistMd font-medium text-base-front-1">{name}</div>
        <div className="flex flex-row items-center">
          <div className="text-xs font-geistRg font-normal text-base-front-2 h-[14px] w-[14px] mr-[1px]">
            {personData?.gender === 'male' ? <FavouriteIcon name="male" className="size-5" /> : <FavouriteIcon name="female" className="size-5" />}
          </div>
          <div className="text-xs font-geistRg font-normal text-base-front-2">
            {moment(personData?.birthdate).toNow(true)}
          </div>
          <div className="h-[3px] w-[3px] bg-base-back-3-transparent rounded-full mx-1" />
          <div className="text-xs font-geistRg font-normal text-base-front-2">{id}</div>
        </div>
      </div>
      <div className="flex flex-row text-xs text-base-front-2">
        <div className="font-normal font-geistRg hidden @[450px]:block">{additionalTxt}</div>
        <div className="flex flex-row min-w-[37px] items-center justify-end mr-3 ml-3 font-geistMd gap-[2px]">
        <ActionIcon name="thumb_up" className="size-3" /> {personData?.job_evaluation}%
        </div>
        <div className="flex flex-row min-w-[37px] items-center justify-end font-geistMd gap-[2px]">
        <HomeIcon name="electric_bolt" className="size-3" /> {attendanceRate ? `${Math.ceil(attendanceRate)}%` : 'Bez hodnocení'}
        </div>
      </div>
    </div>
  );
};

export default TySelectInvitationOption;
